import copy from '@/data/copy/landing-page.json'

function resolve(key) {
  return key.split('.').reduce((acc, part) => (acc == null ? acc : acc[part]), copy)
}

function interpolate(text, params) {
  if (typeof text !== 'string' || !params) return text
  return text.replace(/{{\s*(\w+)\s*}}/g, (match, token) => (
    params[token] !== undefined ? params[token] : match
  ))
}

export function useCopy() {
  function t(key, params) {
    return interpolate(resolve(key), params)
  }

  return { t, copy }
}
